function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { SvgIcon } from '@material-ui/core';
export default function MapIcon(props) {
  let output = /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M512 0c-188.208 0-341.334 153.126-341.334 341.334 0 56.5 14.126 112.52 40.98 162.208l281.688 509.458c3.75 6.792 10.896 11 18.666 11s14.916-4.208 18.666-11l281.792-509.626c26.75-49.52 40.876-105.542 40.876-162.042 0-188.206-153.126-341.332-341.334-341.332zM512 512c-94.104 0-170.666-76.562-170.666-170.666s76.562-170.666 170.666-170.666 170.666 76.562 170.666 170.666c0 94.104-76.562 170.666-170.666 170.666z"
  })));
  return output;
}
